export default "__VITE_ASSET__DKGHDLGv__"